module.exports = "<input class=\"form-control clockpicker put-time\" type=\"text\" name=\"number\" maxlength=\"4\" value=\"08:30\"/>\r\n<span class=\"clock-btn icon icon-clock\"></span>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mytimePicker/mytime-picker.component.html
// module id = ../../../../../app/shared/components/mytimePicker/mytime-picker.component.html
// module chunks = main